<template>
    <div class="main-content">
        <section class="section">
            <div class="section-header">
                <h1 class="text">{{this.$route.meta.title}}</h1>
            </div>

            <div class="section-body">
                <div class="row">
                    <div class="col-12 text-center mt-3" v-if="no_data === null">
                        <div class="half-circle-spinner">
                            <div class="circle circle-1"></div>
                            <div class="circle circle-2"></div>
                        </div>
                    </div>
                    <div class="col-12" v-if="no_data === false">
                        <div class="card bdr-15" >
                            <div class="card-header border-0 pb-4 tb-card">
                                <div class="table-sorting">
                                    <div class="table-search float-left">
                                        <vue-search 
                                            :search="sorting"
                                            @searchdata="getWaitinglist()">
                                        </vue-search>
                                    </div>

                                    <div class="tabel-action float-right">
                                        <button type="submit" v-b-modal.modal-Waitinglist class="btn btn-new"><i class="uil uil-plus mr-2"></i> Add {{this.$route.meta.title}}</button>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="table-responsive bdr-15">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <div class="custom-control custom-checkbox">
                                                        <input type="checkbox" class="custom-control-input" id="all_id" v-model="selectAll">
                                                        <label class="custom-control-label" for="all_id"></label>
                                                    </div>
                                                </th>
                                                <th>Code</th>
                                                <th>Event ID</th>
                                                <th>Package</th>
                                                <th>Title</th>
                                                <th>Type</th>
                                                <th>Category Person</th>
                                                <th width="150px"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="tr-ac" v-for="data in waitinglist.data" :key="data.id" @click.prevent="detailWaitinglist(data)">
                                                <td width="100px" v-on:click.stop=""> 
                                                    <div class="custom-control custom-checkbox" v-if="data.id !== 1">
                                                        <input type="checkbox" class="custom-control-input" v-model="del_waitinglist" :value="data.id" :id="data.id">
                                                        <label class="custom-control-label" :for="data.id"></label>
                                                    </div>
                                                </td>
                                                <td>{{data.code}}</td>
                                                <td>{{data.page_id ? data.page_id : '-'}}</td>
                                                <td>
                                                    {{data.package ? '' : '-'}}
                                                    <div class="premium-label" v-if="data.package === 'PREMIUM' && data.page_id">{{data.package ? data.package : '-'}}</div>
                                                    <div class="standard-label" v-if="data.package === 'STANDARD' && data.page_id">{{data.package ? data.package : '-'}}</div>
                                                </td>
                                                <td>{{data.title ? data.title : ''}}</td>
                                                <td>
                                                    <template v-if="data.type === 'WD'">WEDDING</template>
                                                    <template v-if="data.type === 'WD_MP'">WEDDING & MAPANDES</template>
                                                    <template v-if="data.type === 'MP'">MAPANDES</template>
                                                    <template v-if="data.type === 'BD'">BIRTHDAY</template>
                                                </td>
                                                <td>
                                                    {{data.person_category}}
                                                </td>
                                                <td v-on:click.stop="">
                                                     <b-dropdown id="dropdown-left" text="Settings" variant="primary" class="mt-2 mb-2">
                                                        <template #button-content>
                                                            Settings <i class="uil uil-angle-down"></i>
                                                        </template>
                                                        
                                                        <b-dropdown-item href="#" v-if="data.json && !data.page_id" @click.prevent="approveWaitingList(data)">Approve</b-dropdown-item>
                                                        <b-dropdown-item href="#" v-if="data.json && !data.page_id" @click.prevent="alertResetWaitinglist(data.id)">Reset</b-dropdown-item>
                                                        <b-dropdown-item href="#" v-if="data.json === null && data.page_id === null" @click.prevent="editWaitinglist(data)">Edit</b-dropdown-item>
                                                        <b-dropdown-divider v-if="!data.page_id"></b-dropdown-divider>
                                                        <b-dropdown-item href="#" @click.prevent="copyFormLink(data.id)">Copy Link</b-dropdown-item>
                                                    </b-dropdown>
                                                    <input type="hidden" :id="'formlink' + data.id" :value="$options.filters.FormLink(data)">
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p v-if="waitinglist.total === 0" class="text-center no-data">{{this.$route.meta.title}} data not found</p>
                                </div>
                            </div>
                            <div class="card-footer">
                                <vue-pagination :pagination="waitinglist"
                                                :sorting="sorting"
                                                @paginate="getWaitinglist()">
                                </vue-pagination>
                            </div>
                        </div>
                    </div>
                    <div class="col-12" v-if="no_data === true && sorting.search === ''">
                        <div class="card bdr-15">
                            <div class="card-body card-nitem text-center">
                                <img class="mb-5" src="@/assets/img/no-data.svg" alt="">
                                <div class="nitem-desc">
                                    <h2>{{this.$route.meta.title}} Data Still Empty</h2>
                                    <p>On this page you can create {{this.$route.meta.title}}</p>
                                    <div class="tabel-action">
                                        <button type="submit" v-b-modal.modal-Waitinglist class="btn btn-new"><i class="uil uil-plus mr-2"></i> Add {{this.$route.meta.title}}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-action" v-if="del_waitinglist.length !== 0">
                <div class="card-body">
                    <div class="float-left text-white mt-1">
                        <span v-on:click.prevent="del_waitinglist = []" class="times"><i class="uil uil-times"></i></span>
                        <span><span class="badge">{{del_waitinglist.length}}</span> waitinglist selected</span>
                    </div>
                    <div class="float-right">
                        <div v-on:click.prevent="alertDeleteWaitinglist()" class="btn btn-danger">
                            <i class="uil uil-times"></i> Delete
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <modal-form @getWaitinglist="_getWaitinglist()"></modal-form>
    </div>
</template>

<script>
    import { mapActions, mapState, mapMutations } from 'vuex'
    import VuePagination from "@/components/Pagination.vue";
    import VueSearch from "@/components/Search.vue";
    import ModalForm from '../waitinglist/ModalForm.vue'
    import moment from 'moment'

    export default {
        name: "Waitinglist",
        components: {
            VuePagination,
            VueSearch,
            ModalForm
        },
        data(){
            return {
                del_waitinglist:[],
                no_data: null,
            }
        },
        mounted(){
            this.title = this.$route.meta.title;
            this._getWaitinglist()
        },
        filters: {
            formatDate: function(val){
                if(val){
                    return moment(String(val)).format('HH:MM - DD MMMM YYYY')
                }else{
                    return '-'
                }
            },
            FormLink: function(value) {
                var frameURL;
                if(process.env.NODE_ENV == 'development'){
                    frameURL = 'http://localhost:3000/'
                }else if(process.env.NODE_ENV == 'production'){
                    frameURL = window.location.origin.replace('app.','') + '/'
                }
                return frameURL + 'form/' + value.code
            },
        },
        computed:{
            ...mapState('WaitinglistControl', {
                waitinglist: state => state.waitinglist,
                sorting: state => state.sorting
            }),
            ...mapState('AuthControl', {
                user: state => state.user,
            }),
            selectAll: {
                get: function () {
                    return this.waitinglist.data ? this.del_waitinglist.length == this.waitinglist.data.length : false;
                },
                set: function (value) {
                    var selected = [];

                    if (value) {
                        this.waitinglist.data.forEach(function (waitinglist) {
                            if(waitinglist.id !== 1){
                                selected.push(waitinglist.id);
                            }
                        });
                    }
                    this.del_waitinglist = selected;
                }
            }
        },
        methods: {
            ...mapActions('WaitinglistControl', ['getWaitinglist','deleteWaitinglist','resetWaitinglist']),
            ...mapMutations('WaitinglistControl', ['ASSIGN_FORM','CLEAR_WAITINGLIST','ASSIGN_DATA_APPROVE_WAITINGLIST']),
            
            copyFormLink (id) {
                let formLinkToCopy = document.querySelector('#formlink' + id)
                formLinkToCopy.setAttribute('type', 'text')
                formLinkToCopy.select()

                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'Berhasil' : 'Gagal';
                    this.$toast.success( msg + ' Disalin')
                } catch (err) {
                    this.$toast.warning( 'Maaf, text tidak bisa disalin')
                }

                formLinkToCopy.setAttribute('type', 'hidden')
                window.getSelection().removeAllRanges()
            },
            _getWaitinglist:function(){
                this.getWaitinglist().then(() => {
                    if(this.waitinglist.total == 0){
                        this.no_data = true
                    }else{
                        this.no_data = false
                    }
                })
            },
            editWaitinglist:function(data){
                this.ASSIGN_FORM(data)
                this.$bvModal.show('modal-Waitinglist')
            },
            approveWaitingList:function(data){
                this.ASSIGN_DATA_APPROVE_WAITINGLIST(data)
                this.$bvModal.show('modal-approveWaitinglist')
            },
            alertDeleteWaitinglist:function(){
                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: "Are you sure you delete this waiting list data? This action cannot be undone",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.deleteWaitinglist(this.del_waitinglist).then(
                            this.$toast.success('Successfully Deleting Waiting List'),
                            this.del_waitinglist = []
                        )
                    }
                })
            },
            alertResetWaitinglist:function(id){
                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: "Are you sure you reset this waiting list data? This action cannot be undone",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Reset',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.resetWaitinglist(id).then(
                            this.$toast.success('Successfully Reset Waiting List Data'),
                            this.getWaitinglist()
                        )
                    }
                })
            },
        },
        destroyed(){
            this.CLEAR_WAITINGLIST()
        }
    };

</script>
